import store from "../store/store";
import { IUserType } from "../types";
import { firebase } from "../config/firebase.client";
import { onValue, get, update, push } from "firebase/database";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { UPDATE_WALLET_BALANCE, CLEAR_PAYMENT_MESSAGES, UPDATE_WALLET_BALANCE_FAILED, UPDATE_WALLET_BALANCE_SUCCESS } from "../store/types";



export const clearMessage = () => (dispatch: any) => {
  dispatch({
    type: CLEAR_PAYMENT_MESSAGES,
    payload: null,
  });
};


export const addToWallet = (uid: IUserType['id'], amount: IUserType['id']) => async (dispatch: any) => {
  const { walletHistoryRef, singleUserRef, settingsRef } = firebase;


  if (!uid) return

  dispatch({
    type: UPDATE_WALLET_BALANCE,
    payload: null,
  });

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  onValue(
    singleUserRef(uid),
    (snapshot) => {
      if (snapshot.val()) {
        let walletBalance = parseFloat(snapshot.val().walletBalance);
        const pushToken = snapshot.val().pushToken;
        walletBalance = parseFloat(
          (parseFloat(String(walletBalance)) + parseFloat(String(amount))).toFixed(
            settings.decimal
          )
        );
        let details = {
          type: "Credit",
          amount: parseFloat(String(amount)),
          date: new Date().getTime(),
          txRef: "AdminCredit",
        };
        update(singleUserRef(uid), { walletBalance: walletBalance })
          .then(() => {
            push(walletHistoryRef(uid), details)
              .then(() => {
                dispatch({
                  type: UPDATE_WALLET_BALANCE_SUCCESS,
                  payload: null,
                });
              })
              .catch((error) => {
                dispatch({
                  type: UPDATE_WALLET_BALANCE_FAILED,
                  payload: error.code + ": " + error.message,
                });
              });
            if (pushToken) {
              RequestPushMsg(pushToken, {
                title:
                  store.getState().languagedata.defaultLanguage
                    .notification_title,
                msg: store.getState().languagedata.defaultLanguage
                  .wallet_updated,
                screen: "Wallet",
              });
            }
          })
          .catch((error) => {
            dispatch({
              type: UPDATE_WALLET_BALANCE_FAILED,
              payload: error.code + ": " + error.message,
            });
          });
      }
    },
    { onlyOnce: true }
  );
};

export const withdrawBalance = (profile: IUserType, amount: IUserType['walletBalance']) => async (dispatch: any) => {
  const { withdrawRef } = firebase;

  dispatch({
    type: UPDATE_WALLET_BALANCE,
    payload: null,
  });

  push(withdrawRef, {
    uid: profile.uid,
    processed: false,
    date: new Date().getTime(),
    usertype: profile.usertype,
    amount: parseFloat(String(amount)),
    pix_key: profile.pix_key ? profile.pix_key : "",
    name: profile.firstName + " " + profile.lastName,
    bankName: profile.bankName ? profile.bankName : "",
    bankCode: profile.bankCode ? profile.bankCode : "",
    bankAccount: profile.bankAccount ? profile.bankAccount : "",
  });
};